// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");

function decode(json) {
  return {
          text: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json)
        };
}

var defaultColorRanges = {
  hd: {
    min: 1,
    max: 2,
    color: "#F5817D"
  },
  tl: {
    hd: {
      min: 3,
      max: 3,
      color: "#F9C940"
    },
    tl: {
      hd: {
        min: 4,
        max: 5,
        color: "#52B257"
      },
      tl: /* [] */0
    }
  }
};

function ratingToInt(x) {
  switch (x) {
    case "Void" :
        return -1;
    case "One" :
        return 1;
    case "Two" :
        return 2;
    case "Three" :
        return 3;
    case "Four" :
        return 4;
    case "Five" :
        return 5;
    
  }
}

function clampScale(value) {
  if (value < 1) {
    return 1;
  } else if (value > 10) {
    return 10;
  } else {
    return value;
  }
}

function clampColorRange(minRating, maxRating, range) {
  var min = range.min < minRating ? minRating : (
      range.min > maxRating ? maxRating : range.min
    );
  var max = range.max > maxRating ? maxRating : (
      range.max < minRating ? minRating : range.max
    );
  var max$1 = max < min ? min : max;
  return {
          min: min,
          max: max$1,
          color: range.color
        };
}

function normalizeColorRanges(minRating, maxRating, ranges) {
  if (ranges) {
    return Belt_List.map(ranges, (function (range) {
                  return clampColorRange(minRating, maxRating, range);
                }));
  } else {
    return Belt_List.map(defaultColorRanges, (function (range) {
                  return clampColorRange(minRating, maxRating, range);
                }));
  }
}

function empty(param) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: "",
          description: "",
          translations: /* [] */0,
          minRating: 1,
          maxRating: 5,
          colorRanges: defaultColorRanges,
          answer: undefined
        };
}

function make(text, description, uuid) {
  return {
          id: undefined,
          uuid: uuid,
          text: text,
          description: description,
          translations: /* [] */0,
          minRating: 1,
          maxRating: 5,
          colorRanges: defaultColorRanges,
          answer: undefined
        };
}

function setText(t, text) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: text,
          description: t.description,
          translations: t.translations,
          minRating: t.minRating,
          maxRating: t.maxRating,
          colorRanges: t.colorRanges,
          answer: t.answer
        };
}

function setDescription(t, description) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: description,
          translations: t.translations,
          minRating: t.minRating,
          maxRating: t.maxRating,
          colorRanges: t.colorRanges,
          answer: t.answer
        };
}

function setMinRating(t, minRating) {
  var minRating$1 = clampScale(minRating);
  var maxRating = t.maxRating < minRating$1 ? minRating$1 : t.maxRating;
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          translations: t.translations,
          minRating: minRating$1,
          maxRating: maxRating,
          colorRanges: normalizeColorRanges(minRating$1, maxRating, t.colorRanges),
          answer: t.answer
        };
}

function setMaxRating(t, maxRating) {
  var maxRating$1 = clampScale(maxRating);
  var minRating = t.minRating > maxRating$1 ? maxRating$1 : t.minRating;
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          translations: t.translations,
          minRating: minRating,
          maxRating: maxRating$1,
          colorRanges: normalizeColorRanges(minRating, maxRating$1, t.colorRanges),
          answer: t.answer
        };
}

function setColorRanges(t, colorRanges) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          translations: t.translations,
          minRating: t.minRating,
          maxRating: t.maxRating,
          colorRanges: normalizeColorRanges(t.minRating, t.maxRating, colorRanges),
          answer: t.answer
        };
}

function setAnswerInt(t, value) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          translations: t.translations,
          minRating: t.minRating,
          maxRating: t.maxRating,
          colorRanges: t.colorRanges,
          answer: value
        };
}

function duplicate(q) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: q.text,
          description: q.description,
          translations: q.translations,
          minRating: q.minRating,
          maxRating: q.maxRating,
          colorRanges: q.colorRanges,
          answer: q.answer
        };
}

function id(t) {
  return t.id;
}

function uuid(t) {
  return t.uuid;
}

function text(t) {
  return t.text;
}

function description(t) {
  return t.description;
}

function minRating(t) {
  return t.minRating;
}

function maxRating(t) {
  return t.maxRating;
}

function colorRanges(t) {
  return t.colorRanges;
}

function getTextTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].text;
  } else {
    return t.text;
  }
}

function getDescriptionTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].description;
  } else {
    return t.description;
  }
}

function answer(t) {
  return t.answer;
}

function answered(t) {
  return t.answer !== undefined;
}

function answerToString(t) {
  var value = t.answer;
  if (value !== undefined) {
    return String(value);
  } else {
    return "";
  }
}

function answerToInt(t) {
  return t.answer;
}

function selectedRating(t) {
  return Belt_Option.getWithDefault(t.answer, -1);
}

function answerRange(t) {
  return [
          t.minRating,
          t.maxRating
        ];
}

function decodeColorRange(json) {
  return {
          min: Json_decode.field("min", Json_decode.$$int, json),
          max: Json_decode.field("max", Json_decode.$$int, json),
          color: Json_decode.field("color", Json_decode.string, json)
        };
}

function encodeColorRange(range) {
  return Json_encode.object_({
              hd: [
                "min",
                range.min
              ],
              tl: {
                hd: [
                  "max",
                  range.max
                ],
                tl: {
                  hd: [
                    "color",
                    range.color
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function toJson(withAnswerOpt, t) {
  var withAnswer = withAnswerOpt !== undefined ? withAnswerOpt : false;
  var encodeArray_0 = [
    "id",
    Json_encode.nullable((function (prim) {
            return prim;
          }), t.id)
  ];
  var encodeArray_1 = {
    hd: [
      "text",
      t.text
    ],
    tl: {
      hd: [
        "description",
        t.description
      ],
      tl: {
        hd: [
          "min_rating",
          t.minRating
        ],
        tl: {
          hd: [
            "max_rating",
            t.maxRating
          ],
          tl: {
            hd: [
              "color_ranges",
              Json_encode.array(encodeColorRange, $$Array.of_list(t.colorRanges))
            ],
            tl: /* [] */0
          }
        }
      }
    }
  };
  var encodeArray = {
    hd: encodeArray_0,
    tl: encodeArray_1
  };
  return Json_encode.object_(withAnswer ? ({
                  hd: [
                    "answer",
                    Belt_Option.getWithDefault(t.answer, -1)
                  ],
                  tl: encodeArray
                }) : encodeArray);
}

function decodeTranslation(json) {
  return [
          Json_decode.field("survey_language", (function (param) {
                  return Json_decode.field("name", Json_decode.string, param);
                }), json),
          Json_decode.field("key_string_mapping", decode, json)
        ];
}

function fromJson(json) {
  var minRating = Json_decode.field("category", (function (param) {
          return Json_decode.field("min_rating", (function (param) {
                        return Json_decode.withDefault(1, Json_decode.$$int, param);
                      }), param);
        }), json);
  var maxRating = Json_decode.field("category", (function (param) {
          return Json_decode.field("max_rating", (function (param) {
                        return Json_decode.withDefault(5, Json_decode.$$int, param);
                      }), param);
        }), json);
  var colorRanges = normalizeColorRanges(minRating, maxRating, Json_decode.field("category", (function (param) {
              return Json_decode.field("color_ranges", (function (param) {
                            return Json_decode.withDefault(/* [] */0, (function (param) {
                                          return Json_decode.list(decodeColorRange, param);
                                        }), param);
                          }), param);
            }), json));
  return {
          id: Json_decode.field("category", (function (param) {
                  return Json_decode.field("id", (function (param) {
                                return Json_decode.optional(Json_decode.$$int, param);
                              }), param);
                }), json),
          uuid: Json_decode.field("uid", RandomId$ReactHooksTemplate.fromJson, json),
          text: Json_decode.field("category", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.field("category", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          translations: Json_decode.field("translations", (function (param) {
                  return Json_decode.list(decodeTranslation, param);
                }), json),
          minRating: minRating,
          maxRating: maxRating,
          colorRanges: colorRanges,
          answer: undefined
        };
}

var categoryType = "StarRating";

var minScale = 1;

var maxScale = 10;

exports.categoryType = categoryType;
exports.minScale = minScale;
exports.maxScale = maxScale;
exports.ratingToInt = ratingToInt;
exports.empty = empty;
exports.make = make;
exports.setText = setText;
exports.setDescription = setDescription;
exports.setMinRating = setMinRating;
exports.setMaxRating = setMaxRating;
exports.setColorRanges = setColorRanges;
exports.setAnswerInt = setAnswerInt;
exports.getTextTranslation = getTextTranslation;
exports.getDescriptionTranslation = getDescriptionTranslation;
exports.text = text;
exports.description = description;
exports.minRating = minRating;
exports.maxRating = maxRating;
exports.colorRanges = colorRanges;
exports.answer = answer;
exports.answered = answered;
exports.selectedRating = selectedRating;
exports.toJson = toJson;
exports.fromJson = fromJson;
exports.id = id;
exports.uuid = uuid;
exports.answerToString = answerToString;
exports.answerRange = answerRange;
exports.answerToInt = answerToInt;
exports.duplicate = duplicate;
/* RandomId-ReactHooksTemplate Not a pure module */
